function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m15.554 13.542 0.14048 0.22704c1.4696 1.4703 3.512 2.3785 5.7489 2.3785 2.2477 0 4.2901-0.90815 5.7597-2.3785l0.14048-0.22704 1.1995 0.24866c3.4472 1.4595 5.8678 4.8759 5.8678 8.8545v8.0653l-4.2036 1.5352c-2.842 0.6703-5.7813 1.0163-8.7638 1.0163-2.9717 0-5.911-0.34596-8.753-1.0163l-4.2144-1.5352v-8.0653c0-3.9786 2.4314-7.395 5.8786-8.8545z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m27.828 32.601c-1.4173 0.2566-4.1885 0.7046-6.9549 0.66135-2.7556-0.03243-5.911-0.34596-8.7422-1.0271l-4.2036-1.5244v-8.0653c0-3.9786 2.4206-7.395 5.8678-8.8545l1.1887-0.24866 0.15129 0.22704c1.4696 1.4703 3.5012 2.3785 5.7381 2.3785 2.2477 0 4.2793-0.90815 5.7489-2.3785l0.14048-0.22704c0.91917 0.27611 1.789 0.35339 2.9568 1.0775",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 0.8
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-secondary",
  d: "m20.679 20.04 3.0041 15.449h-17.398l-2.3666-12.184z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(1.0784 0 0 1.079 .23365 -2.1127)",
  d: "m18.958 20.531 2.7856 14.319h-16.133l-2.1944-11.293z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.74164
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m1.5628 29.316c-0.33499-1.8379 0.8753-3.6002 2.7124-3.9353 1.8263-0.34596 3.5877 0.86491 3.9335 2.7028l0.39983 2.1623c0.33499 1.8379-0.8753 3.6002-2.7124 3.9353-1.8263 0.33515-3.5877-0.87572-3.9335-2.7028z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  transform: "matrix(1.0784 0 0 1.079 .23365 -2.1127)",
  d: "m1.2325 29.129c-0.31063-1.7034 0.81164-3.3367 2.5151-3.6474v0c1.6934-0.32065 3.3267 0.80162 3.6474 2.5051l0.37075 2.004c0.31063 1.7034-0.81164 3.3367-2.5151 3.6474v0c-1.6934 0.31063-3.3267-0.81164-3.6474-2.5051z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.74164
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m12.52 8.6987c0-4.4867 3.6417-8.1301 8.1263-8.1301 4.4954 0 8.1263 3.6434 8.1263 8.1301 0 4.4975-3.6309 8.1301-8.1263 8.1301-4.4846 0-8.1263-3.6326-8.1263-8.1301z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  transform: "matrix(.98605 0 0 1 -1.6045 0)",
  fill: "none",
  stroke: "#002060"
}, React.createElement("path", {
  transform: "matrix(1.0784,0,0,1.079,1.7785,-2.1127)",
  d: "m11.623 10.02c0-4.1584 3.3768-7.5352 7.5352-7.5352 4.1684 0 7.5352 3.3768 7.5352 7.5352 0 4.1684-3.3668 7.5352-7.5352 7.5352-4.1584 0-7.5352-3.3668-7.5352-7.5352",
  strokeMiterlimit: 8,
  strokeWidth: 0.74687
}), React.createElement("path", {
  d: "m15.697 7.506c0-1.2866 1.3184-2.3353 2.9393-2.3353 1.6317 0 2.9393 1.0487 2.9393 2.3353 0 1.2974-1.3076 2.3353-2.9393 2.3353-1.6209 0-2.9393-1.0379-2.9393-2.3353",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".96872px"
}), React.createElement("path", {
  d: "m23.305 7.506c0-1.2866 1.3616-2.3353 3.0257-2.3353 1.675 0 3.0257 1.0487 3.0257 2.3353 0 1.2974-1.3508 2.3353-3.0257 2.3353-1.6642 0-3.0257-1.0379-3.0257-2.3353",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: ".96872px"
}), React.createElement("g", {
  strokeMiterlimit: 8,
  strokeWidth: "1.2916px"
}, React.createElement("path", {
  d: "m20.711 5.8626h3.5444"
}), React.createElement("path", {
  d: "m13.726 5.6897h2.5191",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "m28.675 5.6897h2.6285",
  strokeLinecap: "round"
})));

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-primary",
  d: "m31.487 18.404c0-1.0321 0.83637-1.8808 1.8536-1.8808h23.441c1.0172 0 1.831 0.84864 1.831 1.8808v14.243c0 1.0321-0.81376 1.8578-1.831 1.8578h-23.441c-1.0172 0-1.8536-0.8257-1.8536-1.8578z",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m31.487 18.404c0-1.0321 0.83637-1.8808 1.8536-1.8808h23.441c1.0172 0 1.831 0.84864 1.831 1.8808v14.243c0 1.0321-0.81376 1.8578-1.831 1.8578h-23.441c-1.0172 0-1.8536-0.8257-1.8536-1.8578z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m36.731 24.78 0.04521 0.09174c0.5199 0.52753 1.2433 0.87157 2.0344 0.87157 0.81376 0 1.5371-0.34404 2.057-0.87157l0.04521-0.09174 0.42949 0.09174c1.2206 0.52753 2.0796 1.7661 2.0796 3.2111v2.9358l-1.4919 0.55047c-0.9946 0.2523-2.057 0.36698-3.1194 0.36698-1.0398 0-2.1022-0.11468-3.0968-0.36698l-1.5145-0.55047v-2.9358c0-1.445 0.88158-2.6835 2.1022-3.2111z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m36.731 24.78 0.04521 0.09174c0.5199 0.52753 1.2433 0.87157 2.0344 0.87157 0.81376 0 1.5371-0.34404 2.057-0.87157l0.04521-0.09174 0.42949 0.09174c1.2206 0.52753 2.0796 1.7661 2.0796 3.2111v2.9358l-1.4919 0.55047c-0.9946 0.2523-2.057 0.36698-3.1194 0.36698-1.0398 0-2.1022-0.11468-3.0968-0.36698l-1.5145-0.55047v-2.9358c0-1.445 0.88158-2.6835 2.1022-3.2111z",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9.2,
  strokeWidth: 0.8
});

var _ref14 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(.99103 .031668)",
  fill: "#fff",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "m34.836 23.005c0-1.6514 1.3111-3.0276 2.8934-3.0276 1.6049 0 2.8934 1.3762 2.8934 3.0276 0 1.6743-1.2885 3.0276-2.8934 3.0276-1.5823 0-2.8934-1.3532-2.8934-3.0276z"
}), React.createElement("path", {
  d: "m45.686 21.216c0-0.18349 0.13563-0.32111 0.31646-0.32111h8.0698c0.15823 0 0.29386 0.13762 0.29386 0.32111v1.2156c0 0.16055-0.13563 0.29817-0.29386 0.29817h-8.0698c-0.18084 0-0.31646-0.13762-0.31646-0.29817z"
}), React.createElement("path", {
  d: "m45.686 25.436c0-0.18349 0.13563-0.3211 0.31646-0.3211h8.0698c0.15823 0 0.29386 0.13762 0.29386 0.3211v1.2156c0 0.16055-0.13563 0.29817-0.29386 0.29817h-8.0698c-0.18084 0-0.31646-0.13762-0.31646-0.29817z"
}), React.createElement("path", {
  d: "m45.686 29.794c0-0.13762 0.13563-0.27524 0.27126-0.27524h8.1376c0.15823 0 0.27126 0.13762 0.27126 0.27524v1.1009c0 0.16055-0.11302 0.27523-0.27126 0.27523h-8.1376c-0.13563 0-0.27126-0.11468-0.27126-0.27523z"
}));

var _ref15 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  transform: "translate(.99103 .031668)",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 9.2,
  strokeWidth: 0.8
}, React.createElement("path", {
  d: "m34.836 23.005c0-1.6514 1.3111-3.0276 2.8934-3.0276 1.6049 0 2.8934 1.3762 2.8934 3.0276 0 1.6743-1.2885 3.0276-2.8934 3.0276-1.5823 0-2.8934-1.3532-2.8934-3.0276"
}), React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  d: "m45.686 21.216c0-0.18349 0.13563-0.32111 0.31646-0.32111h8.0698c0.15823 0 0.29386 0.13762 0.29386 0.32111v1.2156c0 0.16055-0.13563 0.29817-0.29386 0.29817h-8.0698c-0.18084 0-0.31646-0.13762-0.31646-0.29817z"
}), React.createElement("path", {
  d: "m45.686 25.436c0-0.18349 0.13563-0.3211 0.31646-0.3211h8.0698c0.15823 0 0.29386 0.13762 0.29386 0.3211v1.2156c0 0.16055-0.13563 0.29817-0.29386 0.29817h-8.0698c-0.18084 0-0.31646-0.13762-0.31646-0.29817z"
}), React.createElement("path", {
  d: "m45.686 29.794c0-0.13762 0.13563-0.27524 0.27126-0.27524h8.1376c0.15823 0 0.27126 0.13762 0.27126 0.27524v1.1009c0 0.16055-0.11302 0.27523-0.27126 0.27523h-8.1376c-0.13563 0-0.27126-0.11468-0.27126-0.27523z"
})));

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m40.348 15.33c0-0.2523 0.20344-0.45872 0.45209-0.45872h8.4993c0.27126 0 0.45209 0.20642 0.45209 0.45872v1.8349c0 0.27523-0.18084 0.45872-0.45209 0.45872h-8.4993c-0.24865 0-0.45209-0.18349-0.45209-0.45872z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "icon-tertiary",
  d: "m40.348 15.33c0-0.2523 0.20344-0.45872 0.45209-0.45872h8.4993c0.27126 0 0.45209 0.20642 0.45209 0.45872v1.8349c0 0.27523-0.18084 0.45872-0.45209 0.45872h-8.4993c-0.24865 0-0.45209-0.18349-0.45209-0.45872z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 0.8
});

var SvgMenuPartnerProfile = function SvgMenuPartnerProfile(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuPartnerProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-Partner-Profile.f46d7027.svg";
export { ForwardRef as ReactComponent };